module.exports = __webpack_public_path__ + "static/media/literacy_is_the_foundation.38387c70.png";